// import React from "react"
import pamela from "../hasuracon/images/pamela.png";
import aliSpittel from "../hasuracon/images/ali-spittel.png";
import david from "../hasuracon/images/david.png";
import asraa from "../hasuracon/images/asraa.png";
import richardGirges from "../hasuracon/images/richard-girges.png";
import bostjanCigan from "../hasuracon/images/bostjan-cigan.png";
import maxCantor from "../hasuracon/images/max-cantor.png";
import debbieOBrien from "../hasuracon/images/debbie-o-brien.png";
import tadeAjiboye from "../hasuracon/images/tade-ajiboye.png";
import gordon from "../hasuracon/images/gordon.png";
import uri from "../hasuracon/images/uri.png";
// const sean = require('../hasuracon/images/sean.png');
// const anjana = require('../hasuracon/images/anjana.png');
import jesseMartin from "../hasuracon/images/jesse-martin.png";
import ryanRodriguez from "../hasuracon/images/ryan-rodriguez.png";
import zacharyHughes from "../hasuracon/images/zachary-hughes.png";
import balazsPataki from "../hasuracon/images/balazs-pataki.png";
import kevinMattice from "../hasuracon/images/kevin-mattice.png";
import himshwetGaurav from "../hasuracon/images/himshwet-gaurav.png";
import ronanMccabe from "../hasuracon/images/ronan-mccabe.png";
import johanEliasson from "../hasuracon/images/johan-eliasson.png";
// const farazPatankar = require('../hasuracon/images/faraz-patankar.png');
import romaricPhilogene from "../hasuracon/images/romaric-philogene.png";
import kenanDeniz from "../hasuracon/images/kenan-deniz.png";
import ashwinGoyal from "../hasuracon/images/ashwin-goyal.png";
import avinashMoondra from "../hasuracon/images/avinash-moondra.png";
import fabianSchulze from "../hasuracon/images/fabian-schulze.png";
import kristianFreeman from "../hasuracon/images/kristian-freeman.png";
import tanmaiGopal from "../hasuracon/images/tanmai-gopal.png";
import shahidhMuhammed from "../hasuracon/images/shahidh-muhammed.png";
import tirumaraiSelvan from "../hasuracon/images/tirumarai-selvan.png";
import sezgiUlucam from "../hasuracon/images/sezgi-ulucam.png";
import davidTsai from "../hasuracon/images/david-tsai.png";
import gurumurthySithuraj from "../hasuracon/images/gurumurthy-sithuraj.png";
import jamesGovernor from "../hasuracon/images/james-governor.png";
import karthikSrinivasan from "../hasuracon/images/karthik-srinivasan.png";
import frameBg1 from "./images/frame-bg-1.svg";
import frameBg2 from "./images/frame-bg-2.svg";
import frameBg3 from "./images/frame-bg-3.svg";
import frameBg4 from "./images/frame-bg-4.svg";
import frameBg5 from "./images/frame-bg-5.svg";
import frameBg6 from "./images/frame-bg-6.svg";

import speakerBg1 from "../hasuracon/images/speaker-bg-1.svg";
import speakerBg2 from "../hasuracon/images/speaker-bg-2.svg";
import speakerBg3 from "../hasuracon/images/speaker-bg-3.svg";
import speakerBg4 from "../hasuracon/images/speaker-bg-4.svg";
import speakerBg5 from "../hasuracon/images/speaker-bg-5.svg";
import speakerBg6 from "../hasuracon/images/speaker-bg-6.svg";

import icon1 from "./images/icon-1.svg";
import icon2 from "./images/icon-2.svg";
import icon3 from "./images/icon-3.svg";

const talksDetails = [
  {
    url: "building-a-multi-tenant-geospatial-data-platform-with-hasura",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/building-a-multi-tenant-geospatial-data-platform-with-hasura/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Building a Multi-Tenant Geospatial Data Platform with Hasura",
    videoLink: "https://www.youtube.com/watch?v=vJKEslpFMIA",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/iw4867761",
    time: "10:25 PDT",
    date: "22-06-2020",
    talkType: [
      {
        title: "Multi-Tenant",
        Icon: icon1,
      },
      {
        title: "Data API",
        Icon: icon2,
      },
      {
        title: "Enterprise",
        Icon: icon3,
      },
    ],
    frameBg: frameBg1,
    description: {
      lists: [
        "Airbus UTM is developing digital air traffic management solutions to enable the next age of aviation. Learn about how we're leveraging Hasura Graphql Engine to help us analyze geospatial data to ensure the safety of our future skies.",
      ],
    },
    takeaways: {
      description:
        "Hasura GQL engine can support multi tenant private and shared resources including geospatial data",
    },
    paginationImg: ryanRodriguez,
    paginationName: "Ryan Rodriguez",
    speakersList: [
      {
        textColor: "greenColor",
        profileBg: speakerBg1,
        name: "Ryan Rodriguez",
        img: ryanRodriguez,
        designation: "Senior Engineer",
        org: "Airbus",
        orgLink: "https://www.linkedin.com/company/airbusgroup/",
        linkedInLink: "http://linkedin.com/in/ryanandrodriguez",
        about: "Former roboticist now developing software for the future of flight",
      },
    ],
  },
  {
    url: "accessing-cherres-real-estate-knowledge-graph-with-a-single-graphQL-api",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/accessing-cherres-real-estate-knowledge-graph-with-a-single-graphQL-api/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Accessing Cherre's Real Estate Knowledge Graph with a Single GraphQL API",
    videoLink: "https://www.youtube.com/watch?v=ZjBsgHFBjV0",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/ml4867762",
    time: "10:05 PDT",
    date: "22-06-2020",
    talkType: [
      {
        title: "Data API",
        Icon: icon1,
      },
    ],
    frameBg: frameBg2,
    description: {
      lists: [
        "Why Hasura was the best solution for a company trying to solve a serious data connection problem in Real Estate.",
      ],
    },
    takeaways: {
      description:
        "Why customers care about the features we use. Why this solution was miles better than REST for our use case. How Hasura supports enterprise API clients.",
    },
    paginationImg: kevinMattice,
    paginationName: "Kevin Mattice",
    speakersList: [
      {
        textColor: "blueColor",
        profileBg: speakerBg2,
        name: "Kevin Mattice",
        img: kevinMattice,
        designation: "Head of Product",
        org: "Cherre",
        orgLink: "https://cherre.com/",
        linkedInLink: "https://www.linkedin.com/in/kevin-mattice-93298819/",
        about:
          "Kevin Mattice leads a product team who is building the next generation of real estate data and UI products. He started his career at Jeppesen (now Boeing) helping to pull connected global data into navigation products for pilots. Over the past 3 years, Kevin has helped build products for the real estate industry at Onboard Informatics and then Attom Data Solutions.",
      },
    ],
  },
  {
    url: "a-tale-of-startups-and-graphql",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/a-tale-of-startups-and-graphql/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Adding GraphQL using Hasura to an existing FinTech app to speed up development",
    videoLink: "https://www.youtube.com/watch?v=P9-prdw811M",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/st4867769",
    time: "11:10 PDT",
    date: "22-06-2020",
    talkType: [
      {
        title: "Fintech",
        Icon: icon1,
      },
      {
        title: "Migration",
        Icon: icon2,
      },
    ],
    frameBg: frameBg3,
    description: {
      lists: [
        "Pamela will give a backend developer's prespective on how Hasura helps improving developer efficiency and time to market in a highly dynamic environment.",
      ],
    },
    takeaways: {
      lists: [
        "In a fast changing environment, being able to deliver versatile APIs allows you to deliver features quickly and to adapt to new business requirements easily",
        "Hasura can be easily integrated into an existing architecture and can provide a GraphQL server with no effort",
        "By exploiting Hasura’s authorization system and controlling authorization at field level, you can expose a wide range of data and serve different types of users at the same time without stealing developer time",
      ],
    },
    paginationImg: pamela,
    paginationName: "Pamela Gotti",
    speakersList: [
      {
        textColor: "whiteColor",
        profileBg: speakerBg3,
        name: "Pamela Gotti",
        img: pamela,
        designation: "Senior Software Engineer",
        org: "Credimi",
        orgLink: "https://www.credimi.com/",
        twitterLink: "https://twitter.com/pamela_gotti",
        about:
          "Pamela is Senior Software Engineer in Credimi SPA and CTO of She Tech Italy. Pamela is a software engineer at Credimi SPA and the CTO of SheTech. She loves the versatility of her job, that gave her the opportunity to work in different industries (travel in Expedia, abuse prevention in Google, political intelligence in Policy Brain and finance in Credimi) and to be exposed to different areas of computer science, from coding to data science to software architecture. As CTO of SheTech her mission is to foster diversity in Italy by organizing events that empower women in tech, and to show how fun it is to design and implement software architectures.",
      },
    ],
  },
  {
    url: "making-breaking-api-changes-without-breaking-your-consumer-app",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/making-breaking-api-changes-without-breaking-your-consumer-app/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Making breaking API changes without breaking your consumer app",
    videoLink: "https://www.youtube.com/watch?v=0YbW3XarGqM",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/Vt4868170",
    time: "10:45 PDT",
    date: "22-06-2020",
    talkType: [
      {
        title: "Consumer App",
        Icon: icon1,
      },
      {
        title: "Realtime",
        Icon: icon2,
      },
      {
        title: "Flutter",
        Icon: icon3,
      },
    ],
    frameBg: frameBg4,
    description: {
      lists: [
        "At Swiggy, we saw an emerging business opportunity during COVID and made quick work of releasing an app. We went fully native because Flutter made it really, really easy.",
        "3 weeks in, we're pivoting left, right, and center. After releasing version 85, 10% of our users are still on version 1. Now, we didn't build force updates into version 1, and even if we had, we're not sure if demanding an update is acceptable UX for a new app.",
        "So when business demands a new feature that breaks the consumer app APIs, we resort to some non-traditional use of PostgreSQL magic.",
      ],
    },
    takeaways: {
      description:
        "I will talk about our experience building & quickly iterating on a realtime consumer application with Hasura.",
    },
    paginationImg: ashwinGoyal,
    paginationName: "Ashwin Goyal",
    speakersList: [
      {
        textColor: "yellowColor",
        profileBg: speakerBg4,
        name: "Ashwin Goyal",
        img: ashwinGoyal,
        designation: "New Initiatives",
        org: "Swiggy",
        orgLink: "https://www.linkedin.com/company/swiggy-in/",
        linkedInLink: "https://www.linkedin.com/in/ashwingo/",
        about:
          "Ashwin uses technology to help startups manage and sustain their growth. He was formerly CTO at Bombay Shirts and Pocket Aces. At Swiggy/New Initiatives, he's helping build the next set of products to bring unparalleled convenience to consumers.",
      },
    ],
  },
  {
    url: "powering-autonomous-delivery-logistics-at-matternet",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/powering-autonomous-delivery-logistics-at-matternet/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Powering Autonomous Delivery Logistics at Matternet",
    videoLink: "https://www.youtube.com/watch?v=z788tdog0Kw",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/Ud4870089",
    time: "12:45 PDT",
    date: "22-06-2020",
    talkType: [
      {
        title: "HealthTech",
        Icon: icon1,
      },
    ],
    frameBg: frameBg5,
    paginationImg: davidTsai,
    paginationName: "David Tsai",
    speakersList: [
      {
        textColor: "purpleColor",
        profileBg: speakerBg5,
        name: "David Tsai",
        img: davidTsai,
        org: "Matternet",
        orgLink: "https://www.mttr.net/",
        designation: "Lead Software Engineer",
        githubLink: "https://github.com/tsaiDavid",
      },
    ],
  },
  {
    url: "lessons-learnt-in-using-hasura-for-fintech-apps",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/lessons-learnt-in-using-hasura-for-fintech-apps/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Lessons learnt in using Hasura for fintech apps",
    videoLink: "https://www.youtube.com/watch?v=r5U5JexDgh8",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/Jd4867785",
    time: "10:40 PDT",
    date: "23-06-2020",
    talkType: [
      {
        title: "Fintech",
        Icon: icon1,
      },
    ],
    frameBg: frameBg6,
    description: {
      lists: ["A talk about how Hasura shaped our approach to develop Fintech applications."],
    },
    takeaways: {
      description:
        "Hasura's agility and ability to represent complex data models are very useful to develop multi domain regulated applications.",
    },
    paginationImg: kenanDeniz,
    paginationName: "Kenan Deniz",
    speakersList: [
      {
        textColor: "pinkColor",
        profileBg: speakerBg6,
        name: "Kenan Deniz",
        img: kenanDeniz,
        designation: "Managing Director",
        org: "Unrealists",
        orgLink: "https://unrealists.com/",
        linkedInLink: "https://www.linkedin.com/in/kenandeniz/",
        about:
          "I'm a seasoned tech executive whose career solely dedicated to Data Analytics and Fintech startups.",
      },
    ],
  },
  {
    url: "0-100-experiences-with-hasura-in-production",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/0-100-experiences-with-hasura-in-production/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Building an enterprise multi-tenant SaaS product with Hasura",
    videoLink: "https://www.youtube.com/watch?v=F1S_n9GwLVM",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/BX4867772",
    time: "11:50 PDT",
    date: "22-06-2020",
    talkType: [
      {
        title: "Realtime",
        Icon: icon1,
      },
      {
        title: "Enterprise",
        Icon: icon2,
      },
      {
        title: "Multi-Tenant",
        Icon: icon3,
      },
    ],
    frameBg: frameBg1,
    description: {
      lists: [
        "A retelling of our experiences adopting Hasura at WorkClout. This talk will cover what was involved in learning, deploying, and maintaining Hasura as our primary backend service. Covering all of the lessons learned and benefits gained along the way.",
      ],
    },
    takeaways: {
      lists: [
        "Hasura is real-time on the postgres trigger level, not just on the Hasura subscription level",
        "Hasura != Parse, Firebase",
        "Hasura does not replace your backend engineering team",
        "Hasura can be just as flexible for custom business logic as any custom-written API service",
        "The speed at which you can go to production with Hasura with an idiomatic relational database and an API gateway is game-changing",
      ],
    },
    paginationImg: richardGirges,
    paginationName: "Richard Girges",
    speakersList: [
      {
        textColor: "greenColor",
        profileBg: speakerBg1,
        name: "Richard Girges",
        img: richardGirges,
        designation: "Co-founder & CTO",
        org: "WorkClout",
        orgLink: "https://www.workclout.com/",
        twitterLink: "https://twitter.com/richardgirges",
        about:
          "I'm the Co-founder & CTO of a Y Combinator startup named WorkClout. I've been a software engineer for over 15 years, with most of my experience in open source web development and over half of my career working at Silicon Beach-based startups.",
      },
    ],
  },
  {
    url: "building-a-complex-multi-tenant-saas-application-with-hasura",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/building-a-complex-multi-tenant-saas-application-with-hasura/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title:
      "Architecture and authorization modelling for a complex multi-tenant SaaS platform with Hasura",
    videoLink: "https://www.youtube.com/watch?v=jWFsMI5ffGM",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/qd4867776",
    time: "09:40 PDT",
    date: "22-06-2020",
    talkType: [
      {
        title: "Multi-Tenant",
        Icon: icon1,
      },
      {
        title: "Auth",
        Icon: icon2,
      },
    ],
    frameBg: frameBg2,
    paginationImg: zacharyHughes,
    paginationName: "Zachary Hughes",
    description: {
      lists: [
        "The goal of this talk is to provide attendees with a brief overview of what the Prefect Cloud API does, how Hasura fits into its architecture, and the benefits that Hasura provides to us.",
        "The contents will cover a brief overview of Prefect Cloud in order to provide context. Where Hasura sits in our architecture, both from an infrastructure and a code perspective. Our permissions scheme (we manage both user and tenant-level permissions) and how this works within Hasura. How external users interact with Hasura via Prefect Cloud’s GraphQL API. How Prefect developers interact with Hasura, including the ORM we’ve built around it.",
      ],
    },
    takeaways: {
      lists: [
        "How to architect a public-facing API using Hasura",
        "How to manage permissions in Hasura along one or more dimensions",
        "How to use Hasura to improve external consumption and internal dev productivity",
      ],
    },
    speakersList: [
      {
        textColor: "blueColor",
        profileBg: speakerBg2,
        name: "Zachary Hughes",
        img: zacharyHughes,
        designation: "Cloud Engineer",
        org: "Prefect",
        orgLink: "https://www.prefect.io/",
        githubLink: "https://github.com/zdhughes",
        about:
          "Zachary is currently a Cloud Engineer at Prefect, where he builds and supports the Prefect Cloud API. In his free time, he loves spoiling his dog, hiking, baking, crafting ceramics, and making folks groan with truly awful puns.",
      },
    ],
  },
  {
    url: "exploring-hasura-as-data-access-layer-in-distributed-systems",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/exploring-hasura-as-data-access-layer-in-distributed-systems/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Exploring Hasura as data access layer in distributed systems",
    videoLink: "https://www.youtube.com/watch?v=JecHzZR_A7Y",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/tc4867783",
    time: "10:20 PDT",
    date: "23-06-2020",
    talkType: [
      {
        title: "serverless",
        Icon: icon1,
      },
      {
        title: "Data API",
        Icon: icon2,
      },
    ],
    frameBg: frameBg3,
    description: {
      lists: [
        "This talk will focus on two aspects of distributed systems: inter-service communication and database access across services. We will briefly discuss the related challenges and potential solutions using Hasura.",
      ],
    },
    takeaways: {
      lists: [
        "As a data access layer in serverless architecture",
        "As a unified API for inter-service communication",
        "To support/build an event driven system",
      ],
    },
    paginationImg: himshwetGaurav,
    paginationName: "Himshwet Gaurav",
    speakersList: [
      {
        textColor: "whiteColor",
        profileBg: speakerBg3,
        name: "Himshwet Gaurav",
        img: himshwetGaurav,
        designation: "Founder & Senior Product Engineer",
        org: "Krafteer",
        orgLink: "https://krafteer.com/",
        linkedInLink: "https://www.linkedin.com/in/himshwet/",
        about:
          "Himshwet founded and leads a digital product studio in Tallinn, Estonia. He has a decade plus experience in product design and software engineering. For past three years he has been working extensively with GraphQL and event driven architectures. In his most recent project he built a bespoke CRM solution on top of Hasura using serverless architecture.",
      },
    ],
  },
  {
    url: "hasuras-role-in-data-journalism",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/hasuras-role-in-data-journalism/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Hasura's Role in Data Journalism",
    videoLink: "https://www.youtube.com/watch?v=1NgZ_iYcmz0",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/Xk4868024",
    time: "12:30 PDT",
    date: "24-06-2020",
    talkType: [
      {
        title: "Data API",
        Icon: icon1,
      },
    ],
    frameBg: frameBg4,
    description: {
      lists: [
        "GraphQL and Hasura are powering important data journalism. ProPublica, The Chicago Reporter, Stanford University, the San Francisco Chronicle, the Washington Post, and others are using GraphQL to power reporting and news. Learn how The Chicago Reporter is using Hasura to manage and analyze local campaign finance data and criminal justice data, how we use Hasura's permissions model and GIS support to elegantly solve classic problems in data journalism, and how we're experimenting with Hasura remote joins to unlock new possibilities for combining public data.",
      ],
    },
    paginationImg: asraa,
    paginationName: "Asraa Mustufa",
    paginationImgTwo: david,
    paginationNameTwo: "David Eads",
    speakersList: [
      {
        textColor: "yellowColor",
        profileBg: speakerBg4,
        name: "Asraa Mustufa",
        img: asraa,
        designation: "Digital Editor",
        org: "The Chicago Reporter",
        orgLink: "https://www.chicagoreporter.com/",
        twitterLink: "https://twitter.com/asraareports",
      },
      {
        textColor: "purpleColor",
        profileBg: speakerBg5,
        name: "David Eads",
        img: david,
        designation: "Des+Delivery Editor",
        org: "The Chicago Reporter",
        orgLink: "https://www.chicagoreporter.com/",
        twitterLink: "https://twitter.com/eads",
      },
    ],
  },
  {
    url: "bootstrapping-a-medical-mask-listing-platform-in-three-days-using-hasura",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/bootstrapping-a-medical-mask-listing-platform-in-three-days-using-hasura/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Bootstrapping a medical mask listing platform in three days using Hasura",
    videoLink: "https://www.youtube.com/watch?v=2QJoNZ35us8",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/Sn4868058",
    time: "11:10 PDT",
    date: "24-06-2020",
    talkType: [
      {
        title: "Next",
        Icon: icon1,
      },
      {
        title: "Productivity",
        Icon: icon2,
      },
    ],
    frameBg: frameBg6,
    description: {
      lists: [
        "When the demand for masks spiked during the Covid19 crisis, Fabian and two of his friends decided to build a listing platform to match buyers and suppliers of protective gear. The main goal was to fight cutthroat prices and make the entire market more transparent.",
        "To help quickly and keep costs low, they built the first MVP in just three days with the help of Hasura, NextJS, Digital Ocean, and Vercel.",
        "In this talk, Fabian will tell the story with its ups and downs, go over the platform's architecture, discuss scaling, and how to implement transaction emails with Hasura.",
      ],
    },
    takeaways: {
      lists: [
        "Reference architecture for a listing platform, including hosting of Hasura, Postgres, the React frontend, user uploads and CDN caching",
        "Insights into load test results of Hasura and how to utilize Cloudflare Workers as a caching layer and NextJS static optimization to decrease the load of Hasura",
      ],
    },
    paginationImg: fabianSchulze,
    paginationName: "Fabian Schulze",
    speakersList: [
      {
        textColor: "pinkColor",
        profileBg: speakerBg6,
        name: "Fabian Schulze",
        img: fabianSchulze,
        org: "Code-Consulting",
        designation: "Freelancer / Founder",
        twitterLink: "https://twitter.com/breytex",
        about:
          "Hey, I am Fabian, a freelance software developer from Aachen, Germany. My main focus currently is on the React ecosystem. I like to experiment a lot with different frameworks and approaches on how to build reliable and fun to use web applications. Apart from software development, I like long motorcycle adventures, (drone-)photography and mountain biking. I am always interested in getting to know new people who either share my hobbies or my fable for awesome tech. Feel free to say hi :-)",
      },
    ],
  },
  {
    url: "integrating-hasura-into-an-existing-graphql-ecosystem-with-remote-schemas",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/integrating-hasura-into-an-existing-graphql-ecosystem-with-remote-schemas/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Integrating Hasura into an Existing GraphQL Ecosystem with Remote Schemas",
    videoLink: "https://www.youtube.com/watch?v=rb76I-gZdqg",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/rl4867781",
    time: "9:55 PDT",
    date: "23-06-2020",
    talkType: [
      {
        title: "Migration",
        Icon: icon1,
      },
      {
        title: "Remote Joins",
        Icon: icon2,
      },
    ],
    frameBg: frameBg1,
    description: {
      lists: [
        "Making GraphQL applications with Hasura gives us many powerful features out of the box but the one we rarely talk about is remote schemas. Remote schemas enable us to do remote relations on our data to another GraphQL server which unlocks a whole new world of ways in which you can build your applications and schemas.",
        "In this talk we will present a small demo on how to use remote schemas to connect to another GraphQL server. Afterwards we will also showcase an example of how we implemented a larger GraphQL ecosystem for an organization to create a future-proof architecture where all further applications can be built in multiple Hasura environments.",
      ],
    },
    takeaways: {
      description:
        "A remote schemas example and how-to, the power of remote schemas and bonuses it gives  you in developing a GraphQL ecosystem for a big organization, a real life case in where we used remote schemas to make integration easier for us.",
    },
    paginationImg: bostjanCigan,
    paginationName: "Boštjan Cigan",
    speakersList: [
      {
        textColor: "greenColor",
        profileBg: speakerBg1,
        name: "Boštjan Cigan",
        img: bostjanCigan,
        designation: "Head of GraphQL Department",
        org: "RESULT d.o.o.",
        orgLink: "https://www.linkedin.com/company/result-d-o-o-/",
        twitterLink: "https://twitter.com/bostjan_cigan",
        about:
          "I am a full-stack developer with a masters degree in Computer and Information Science (University of Ljubljana) and over five years of experience. Currently I specialize in the creation of highly scaled systems focusing on the stack containing React, GraphQL, Express and OpenShift but am also versatile in other development environments and have a proven track record of working with WordPress. I also have a high passion for mentoring. I am a professor at Erudio University (head of Programming II course) am an instructor at Smart Ninja (coding school for beginners) and a mentor at Thinkful.",
      },
    ],
  },
  {
    url: "rails-vs-hasura",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl: "https://hasura.io/events/hasura-con-2020/talks/rails-vs-hasura/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Shifting to Hasura: Lessons from a Rails developer",
    videoLink: "https://www.youtube.com/watch?v=fGwofFTAvBY",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/iI4868055",
    time: "10:55 PDT",
    date: "24-06-2020",
    talkType: [
      {
        title: "Rails",
        Icon: icon1,
      },
      {
        title: "Migration",
        Icon: icon2,
      },
    ],
    frameBg: frameBg2,
    description: {
      lists: [
        "What's it like going from \"The Rails Way\" to Hasura? We'll cover similarities and differences between these two open source web development platforms, and how to shift your mindset when developing in Hasura but all your past experience is in Rails. We'll discuss monolithic MVC vs. Event-driven SOA, REST vs. GraphQL, the ORM, and foundational pillars that shape each technology.",
      ],
    },
    takeaways: {
      description:
        "Having used both Rails and Hasura in fast-moving production environments, my goal is to help you all shift your mindset from Rails to Hasura (without getting into which is better!). We’ll highlight some major architectural differences and map some shared concepts. You’ll have less surprises and more confidence as you get started with Hasura.",
    },
    paginationImg: avinashMoondra,
    paginationName: "Avinash Moondra",
    speakersList: [
      {
        textColor: "blueColor",
        profileBg: speakerBg2,
        name: "Avinash Moondra",
        img: avinashMoondra,
        designation: "Software Engineer",
        linkedInLink: "https://www.linkedin.com/in/avimoondra/",
        about:
          "Avi is an engineer, mostly in web and startups so far. In his free time, you can find him working on https://fishbowl-game.com/, in the kitchen, or running many miles at a time.",
      },
    ],
  },
  {
    url: "building-your-own-code-driven-workflow-on-top-of-Hasura-declarative-configuration",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/building-your-own-code-driven-workflow-on-top-of-Hasura-declarative-configuration/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Building your own code-driven workflow on top of Hasura's declarative configuration",
    videoLink: "https://www.youtube.com/watch?v=ILKsJ8l22KQ",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/VL4868023",
    time: "12:20 PDT",
    date: "23-06-2020",
    talkType: [
      {
        title: "Java",
        Icon: icon1,
      },
      {
        title: "Tooling",
        Icon: icon2,
      },
    ],
    frameBg: frameBg3,
    description: {
      lists: [
        "Configuration of Hasura is usually done via the HasuraConsole. However during development - especially in case of a Spring web application using Hibernate as the ORM - the database schema may change a lot and it is tedious to always set table and relationship tracking, permissions etc. on a newly generated database in the HasuraConsole. With HasuraConfigurator when the data model changes in Java the HasuraConfigurations can be regenerated and automatically loaded into Hasura thus the data model and the HasuraConfiguration will always be in sync.",
        "As an added bonus, HasuraConfigurator also makes it very easy to add various customisations on the model, like defining aliases for column names to match their Java equivalent, or renaming root operations so that they look better (ie. camelCase instead of snake_case) in the graphql schema.",
      ],
    },
    takeaways: {
      description:
        "Makes your life much easier if you develop Java/Spring applications and want to use Hasura as your GraphQL server.",
    },
    paginationImg: balazsPataki,
    paginationName: "Balázs E. Pataki",
    speakersList: [
      {
        textColor: "whiteColor",
        profileBg: speakerBg3,
        name: "Balázs E. Pataki",
        img: balazsPataki,
        designation: "Senior research associate",
        org: "SZTAKI - Hungary",
        orgLink: "https://www.sztaki.hu/en",
        githubLink: "https://github.com/beepsoft",
      },
    ],
  },
  {
    url: "bugs-cant-hide-a-full-stack-exploration-in-type-safety",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/bugs-cant-hide-a-full-stack-exploration-in-type-safety/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Follow the Types: A full stack exploration",
    videoLink: "https://www.youtube.com/watch?v=ly05IV5isf4",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/PD4868062",
    time: "11:20 PDT",
    talkType: [
      {
        title: "Typesafety",
        Icon: icon1,
      },
    ],
    level: "Talk level",
    frameBg: frameBg4,
    description: {
      lists: [
        "Hasura provides an excellent base for your data. But can you extend that reliability to your business logic, even across multiple languages? In this talk we will explore the guarantees provided by combining strong type systems with GraphQL.",
      ],
    },
    takeaways: {
      description:
        "It will provide ideas and examples of how to use Hasura as part of a modern, reliable webapp codebase.",
    },
    paginationImg: ronanMccabe,
    paginationName: "Ronan McCabe",
    speakersList: [
      {
        textColor: "yellowColor",
        profileBg: speakerBg4,
        name: "Ronan McCabe",
        img: ronanMccabe,
        designation: "Boss",
        org: "Tarbh",
        orgLink: "https://tarbh.engineering/",
        personalLink: "https://ronanmccabe.app",
        about: "I am a programmer from Ireland.",
      },
    ],
  },
  {
    url: "graphql-everywhere-use-hasura-graphql-mesh-to-create-the-ultimate-data-graph",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/graphql-everywhere-use-hasura-graphql-mesh-to-create-the-ultimate-data-graph/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "GraphQL Everywhere: Use Hasura + GraphQL Mesh to create the ultimate data graph",
    videoLink: "https://www.youtube.com/watch?v=8Jr3tSTf5-E",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/Zy4867867",
    time: "12:00 PDT",
    date: "23-06-2020",
    talkType: [
      {
        title: "Remote Joins",
        Icon: icon1,
      },
      {
        title: "Enterprise",
        Icon: icon2,
      },
      {
        title: "Java",
        Icon: icon3,
      },
    ],
    frameBg: frameBg5,
    description: {
      lists: [
        "Hasura set the standard on fast graph from your own data.  What if we could make any data to become a graph and combine it easily our Hasura's graph? GraphQL Mesh is a new and exciting library that helps create a GraphQL SDK from any data source (Swagger/openapi, gRPC, SOAP and others). Now your can have all your data in a single graph, from any source, legacy or new, without doing a lot of manual work. In this talk I'm doing to demonstrate the amazing power Hasura and GraphQL Mesh can provide for any app out there!",
      ],
    },
    takeaways: {
      description:
        "That having GraphQL with Hasura is not confined anymore to your Postgres DB. You can query your legacy services and connect them for a powerful modern experience.",
    },
    paginationImg: uri,
    paginationName: "Uri Goldshtein",
    speakersList: [
      {
        textColor: "purpleColor",
        profileBg: speakerBg5,
        name: "Uri Goldshtein",
        img: uri,
        designation: "Founder",
        org: "The Guild",
        orgLink: "https://the-guild.dev/",
        twitterLink: "https://twitter.com/urigoldshtein",
        about:
          "Uri Goldshtein is the founder of The Guild, a group of open-source developers working around the world. They help create important open source libraries, mostly around GraphQL, to support large companies going through technological transformations.",
      },
    ],
  },
  {
    url: "how-to-deploy-hasura-on-aws-using-a-language-you-already-know",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/how-to-deploy-hasura-on-aws-using-a-language-you-already-know/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Enterprise grade deployment of your Hasura stack on AWS",
    videoLink: "https://www.youtube.com/watch?v=za0i5yLdgxI",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/Hv4867864",
    time: "11:35 PDT",
    date: "23-06-2020",
    talkType: [
      {
        title: "Enterprise",
        Icon: icon1,
      },
    ],
    frameBg: frameBg1,
    description: {
      lists: [
        "This talk will introduce you to the new AWS Cloud Development Kit (CDK) and use it to deploy an enterprise ready Hasura stack. You will learn the fundamental requirements of an enterprise Hasura deployment and how CDK enables you to manage your AWS infrastructure using a language you already know. Some familiarity with regular AWS concepts such as VPC and RDS would be useful but is not required.",
      ],
    },
    takeaways: {
      lists: [
        "An introduction to enterprise considerations for Hasura deployments.",
        "An introduction to CDK fundamentals and how CDK can enable infrastructure as code using a familiar language.",
      ],
    },
    paginationImg: gordon,
    paginationName: "Gordon Johnston",
    speakersList: [
      {
        textColor: "greenColor",
        profileBg: speakerBg1,
        name: "Gordon Johnston",
        img: gordon,
        designation: "Director / Co-Founder",
        org: "Lineup Ninja",
        orgLink: "https://lineup.ninja/",
        twitterLink: "https://twitter.com/gordonj",
        about:
          "Gordon has worked in the internet industry for 20 years in roles including architecture and development and for the last 3 years as the technical brains behind Lineup Ninja, an Hasura powered Speaker Management platform. He has worked with Hasura since the early alpha versions and is active in the community. He is also a keen advocate for mental health issues.",
      },
    ],
  },
  {
    url: "swiftui-with-hasura-and-apollo-the-good-The-Bad-and-the-unspeakably-ugly",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/swiftui-with-hasura-and-apollo-the-good-The-Bad-and-the-unspeakably-ugly/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "SwiftUI with Hasura and Apollo - The Good, The Bad, and the Unspeakably Ugly",
    videoLink: "https://www.youtube.com/watch?v=Gw-arOrVIwg",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/uc4868050",
    time: "10:20 PDT",
    date: "24-06-2020",
    talkType: [
      {
        title: "Swift",
        Icon: icon1,
      },
      {
        title: "UI",
        Icon: icon2,
      },
    ],
    frameBg: frameBg2,
    description: {
      lists: [
        "We recently launched a project on top of SwiftUI.  This was our first foray into iOS programming since before the days of Swift.  In some ways, SwiftUI is very react-like.  In other ways, its incredibly different.  We will cover some of the lessons learned and techniques we've discovered for effectively and safely using Apollo and Hasura in a SwiftUI project.",
      ],
    },
    takeaways: {
      description:
        "The hasura community should have a sense of what is the same and what is different from writing a SwiftUI app vs a React app.  The idea is that with this talk, an engineer who has basic Swift / SwiftUI competency could quickly ramp up and add a Hasura / graphql backend.",
    },
    paginationImg: maxCantor,
    paginationName: "Max Cantor",
    speakersList: [
      {
        textColor: "blueColor",
        profileBg: speakerBg2,
        name: "Max Cantor",
        img: maxCantor,
        designation: "CEO and litter scooper",
        org: "meow.vc",
        orgLink: "http://meow.vc/",
        personalLink: "https://www.maxcantor.com/",
        about:
          "Max Cantor is an entrepreneurial leader with deep technical skills in full stack web development. He was previously Head of Product engineering at Atrium where he led multiple teams of engineers.  Prior to Atrium, he was Director of Research Engineering at Nitro Software after their acquisition of Docmunch, where he was a co-founder.  He is deeply passionate about elegant technology and people management.  Outside of work, he is an instrument rated private pilot and part time crossfit and weightlifting coach.",
      },
    ],
  },
  {
    url: "how-hasura-makes-learning-code-easier",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/how-hasura-makes-learning-code-easier/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "How Hasura makes Learning Code Easier",
    videoLink: "https://www.youtube.com/watch?v=mwVorhTnebo",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/Yw4868033",
    time: "9:05 PDT",
    date: "24-06-2020",
    talkType: [
      {
        title: "Beginner",
        Icon: icon1,
      },
    ],
    frameBg: frameBg3,
    description: {
      lists: [
        "You normally need to learn all layers of the stack to build an awesome portfolio application by yourself. Hasura makes it so that you only need to worry about the frontend. This makes learning code and building portfolio projects more fun and accessible, keeping learners hooked. In this talk, we'll discuss using Hasura to allow new programmers to build complex web applications much more quickly and easily than ever before.",
      ],
    },
    takeaways: {
      lists: ["How to teach Hasura", "How accessible getting up and running with Hasura is"],
    },
    paginationImg: aliSpittel,
    paginationName: "Alison Spittel",
    speakersList: [
      {
        textColor: "whiteColor",
        profileBg: speakerBg3,
        name: "Alison Spittel",
        img: aliSpittel,
        designation: "Faculty Lead",
        org: "General Assembly",
        orgLink: "https://generalassemb.ly/",
        twitterLink: "https://twitter.com/ASpittel",
        about:
          "Ali teaches people to code. She loves Python, JavaScript, and talking about code. She is most interested in the intersection of programming, art, and education. She's a distinguished faculty member at General Assembly, where she teaches people how to code. When Ali's not working, you can find her watching New England sports, competing on CodeWars, taking runs around the city, rock climbing, or participating in coding community events. Ali also blogs about code and her life surrounding it. Her writing has gotten over a million readers in the past year. She is also a Google Developer Expert and Mozilla Tech Speaker.",
      },
    ],
  },
  {
    url: "going-static-in-a-dynamic-world-with-hasura-and-Nuxt-js",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/going-static-in-a-dynamic-world-with-hasura-and-Nuxt-js/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Going Static in a Dynamic World with Hasura and Nuxt.js",
    videoLink: "https://www.youtube.com/watch?v=nO6hz2ZdhoA",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/iO4868047",
    time: "10:10 PDT",
    date: "24-06-2020",
    talkType: [
      {
        title: "Nuxt",
        Icon: icon1,
      },
      {
        title: "JAMstack",
        Icon: icon2,
      },
    ],
    frameBg: frameBg4,
    description: {
      lists: [
        "This talk covers how to use static sites with Hasura, from setting up your endpoint, adding the query to Nuxt.js to display your data with Apollo and GraphQL, how to setup a hook so that it triggers a deploy of your site on content change as static sites need to be redeployed on content change. How to secure your API. Showcasing the static module of Nuxt.js which means you don't have to expose your API call thanks to only calling the API on build and the payload on page change and refresh thanks to the new static module of Nuxt.js.",
      ],
    },
    takeaways: {
      description:
        "That you can use static sites with Hasura, that it is easy to set up and that you can change your content and regenerate your site and it's not difficult to setup.",
    },
    paginationImg: debbieOBrien,
    paginationName: "Debbie O'Brien",
    speakersList: [
      {
        textColor: "yellowColor",
        profileBg: speakerBg4,
        name: "Debbie O'Brien",
        img: debbieOBrien,
        designation: "Head of Learning and Developer Advocate",
        org: "NuxtJS",
        orgLink: "https://nuxtjs.org/",
        twitterLink: "https://twitter.com/debs_obrien",
        about:
          "Debbie O’Brien is Head of Learning and Developer Advocate at NuxtJS, the progressive VueJS framework. Debbie has over 10 years experience in Frontend development. She has worked as a Tech Lead and consultant for many important clients with varios technologies and often with a strong focus on performance. She has lead teams both in house and remotely as well as giving workshops and training. She has many years of experience as a mentor for online learning platforms, Treehouse and OpenClassrooms. Debbie is a Microsoft Most Valuable Professional in developer technologies, Google Developer Expert in web technologies and Cloudinary Media Developer Expert.",
      },
    ],
  },
  {
    url: "building-realtime-and-collaborative-games-with-hasura-unity",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/building-realtime-and-collaborative-games-with-hasura-unity/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Building realtime and collaborative games with Hasura & Unity",
    videoLink: "https://www.youtube.com/watch?v=WkbWfgjUKp4",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/Wx4868051",
    time: "10:35 PDT",
    date: "24-06-2020",
    talkType: [
      {
        title: "Unity",
        Icon: icon1,
      },
      {
        title: "Realtime",
        Icon: icon2,
      },
    ],
    frameBg: frameBg6,
    description: {
      lists: [
        "Unity Meets Hasura is a talk on using Hasura with Unity. It intends to demystify using GraphQL solutions with Unity and highlight the benefits of Hasura in game development.",
      ],
    },
    takeaways: {
      description: "Properly interfacing Hasura with Unity.",
    },
    paginationImg: tadeAjiboye,
    paginationName: "Tade Ajiboye",
    speakersList: [
      {
        textColor: "pinkColor",
        profileBg: speakerBg6,
        name: "Tade Ajiboye",
        img: tadeAjiboye,
        designation: "Unity Developer",
        twitterLink: "https://twitter.com/gazuntype",
        about:
          "Tade Ajiboye is a 23 year old Unity developer from Nigeria who loves to create exciting experiences in the form of games, VR and AR. He also enjoys developing tools that help the creation process.",
      },
    ],
  },
  {
    url: "blazing-fast-hasura-developer-experience-using-nhost",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/blazing-fast-hasura-developer-experience-using-nhost/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Blazing fast (and smooth) Hasura developer experience using Nhost",
    videoLink: "https://www.youtube.com/watch?v=69y4Z9QObAM",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/bZ4868035",
    time: "9:20 PDT",
    date: "24-06-2020",
    talkType: [
      {
        title: "Tooling",
        Icon: icon1,
      },
    ],
    frameBg: frameBg1,
    description: {
      lists: [
        "Think Netlify meets Google Firebase but with SQL, GraphQL (Hasura!) and 100% open source. Enter the world of Nhost.",
      ],
    },
    paginationImg: johanEliasson,
    paginationName: "Johan Eliasson",
    speakersList: [
      {
        textColor: "greenColor",
        profileBg: speakerBg1,
        name: "Johan Eliasson",
        img: johanEliasson,
        designation: "Founder",
        org: "Nhost",
        orgLink: "https://nhost.io/",
        twitterLink: "https://twitter.com/elitasson",
        about: "Founder of Nhost",
      },
    ],
  },
  {
    url: "blazing-fast-deployment-of-a-fullstack-angular-GraphQL-hasura-app-with-qovery",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/blazing-fast-deployment-of-a-fullstack-angular-GraphQL-hasura-app-with-qovery/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Blazing fast deployment of a fullstack Angular, GraphQL & Hasura App with Qovery",
    videoLink: "https://www.youtube.com/watch?v=L1vxrxEA5u4",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/AK4868043",
    time: "9:45 PDT",
    date: "24-06-2020",
    talkType: [
      {
        title: "Tooling",
        Icon: icon1,
      },
      {
        title: "Angular",
        Icon: icon2,
      },
    ],
    frameBg: frameBg2,
    description: {
      lists: [
        "Qovery helps developers to deploy their applications in the cloud in just a few seconds. In this talk, I will show you why Qovery is the perfect solution to deploy your Hasura application. By the end of this talk, you will be able to deploy a fullstack Angular, GraphQL & Hasura App in production in less than a minute.",
      ],
    },
    takeaways: {
      description:
        "You can deploy Hasura with PostgreSQL to a scalable cloud solution using one command in less than a minute.",
    },
    paginationImg: romaricPhilogene,
    paginationName: "Romaric Philogène",
    speakersList: [
      {
        textColor: "blueColor",
        profileBg: speakerBg2,
        name: "Romaric Philogène",
        img: romaricPhilogene,
        designation: "CEO & Co-Founder",
        org: "Qovery",
        orgLink: "https://www.qovery.com/",
        twitterLink: "https://twitter.com/rophilogene",
      },
    ],
  },
  {
    url: "hasura-and-the-graphql-cms",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl: "https://hasura.io/events/hasura-con-2020/talks/hasura-and-the-graphql-cms/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Hasura and the GraphQL CMS",
    videoLink: "https://www.youtube.com/watch?v=yYHiEArPW20",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/Ag4868039",
    time: "9:30 PDT",
    date: "24-06-2020",
    talkType: [
      {
        title: "Remote Joins",
        Icon: icon1,
      },
    ],
    frameBg: frameBg3,
    description: {
      lists: [
        'Hasura is a powerful BaaS for building rich applications on GraphQL. GraphCMS, and the other GraphQL native headless CMS enable content teams with intuitive UIs and workflows. This talks hows how to architect the two together with remote schemas for the ultimate "time-to-market" speed boost.',
      ],
    },
    takeaways: {
      lists: [
        "Use Hasura as the glue for your entire GraphQL service stack.",
        "GraphQL is a technology worth betting on.",
        "Use a headless CMS for CMS things and a BaaS for BaaS things.",
      ],
    },
    paginationImg: jesseMartin,
    paginationName: "Jesse Martin",
    speakersList: [
      {
        textColor: "whiteColor",
        profileBg: speakerBg3,
        name: "Jesse Martin",
        img: jesseMartin,
        designation: "Developer Advocate",
        org: "GraphCMS GmbH",
        orgLink: "https://graphcms.com/",
        twitterLink: "https://twitter.com/motleydev",
        about:
          "Jesse Martin is a developer advocate for GraphCMS where he promotes the future of GraphQL for developer-driven companies around the world. He's a product fanatic and can talk about branding and content strategy all day.",
      },
    ],
  },
  {
    url: "bringing-graphql-to-the-edge",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl: "https://hasura.io/events/hasura-con-2020/talks/bringing-graphql-to-the-edge/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Bringing GraphQL to the edge",
    videoLink: "https://www.youtube.com/watch?v=KgYKsO_bHtM",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/dn4867786",
    time: "10:50 PDT",
    date: "23-06-2020",
    talkType: [
      {
        title: "serverless",
        Icon: icon1,
      },
    ],
    frameBg: frameBg4,
    description: {
      lists: [
        "GraphQL has changed the way that we write web applications, by allowing frontend developers to easily build data-driven applications without needing to manage APIs or rely on backend developers. That being said, your GraphQL APIs still live somewhere — today, likely a centrally located “origin” on a cloud provider, such as AWS or Azure.",
        "Instead of serving GraphQL requests from a centrally located origin, sitting in a remote location away from the user, what if we could bring our GraphQL server closer to the user? Using Cloudflare Workers, we can deploy our GraphQL server to each of Cloudflare's edge servers around the world, milliseconds from the users. When a user of our application makes a GraphQL request, our edge servers will respond in lightning-fast fashion.",
        "In this talk, I'll cover why edge computing is so exciting, and how using Hasura, GraphQL, and Cloudflare Workers can make a massive impact on your application's scalability, cost, and performance. I'll also show an example open-source project that I've created that shows Cloudflare Workers acting as a caching/performance proxy for a Hasura GraphQL engine.",
      ],
    },
    takeaways: {
      lists: [
        '"The edge" is an exciting new deploy surface for web developers, offering the potential to improve performance and simplify how we architect our applications',
        "Cloudflare Workers makes it super easy to deploy serverless/edge code, and the network provided by Cloudflare has huge performance + latency implications for users of your app",
        "Hasura and GraphQL as an ecosystem can benefit greatly from edge computing, and it could be the next big paradigm shift in how we think about architecting GraphQL applications",
      ],
    },
    paginationImg: kristianFreeman,
    paginationName: "Kristian Freeman",
    speakersList: [
      {
        textColor: "yellowColor",
        profileBg: speakerBg4,
        name: "Kristian Freeman",
        img: kristianFreeman,
        org: "Cloudflare",
        orgLink: "https://www.cloudflare.com/",
        designation: "Developer Advocate",
        twitterLink: "https://twitter.com/signalnerve/",
        about:
          "I'm a software developer, writer, and teacher. I work at Cloudflare as the Developer Advocate for Cloudflare Workers, make videos on programming on the Bytesized YouTube channel, and organize Byteconf, a remote developer conference series.",
      },
    ],
  },
  {
    url: "graphql-as-infrastructure",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl: "https://hasura.io/events/hasura-con-2020/talks/graphql-as-infrastructure/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Invisible GraphQL: When GraphQL becomes infrastructure",
    videoLink: "https://www.youtube.com/watch?v=7hvslmK0aa4",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/vY4867775",
    time: "9:10 PDT",
    date: "22-06-2020",
    talkType: [
      {
        title: "Keynote",
        Icon: icon1,
      },
      {
        title: "Hasura Team",
        Icon: icon2,
      },
    ],
    frameBg: frameBg5,
    paginationImg: tanmaiGopal,
    paginationName: "Tanmai Gopal",
    speakersList: [
      {
        textColor: "purpleColor",
        profileBg: speakerBg5,
        name: "Tanmai Gopal",
        img: tanmaiGopal,
        org: "Hasura",
        orgLink: "https://hasura.io/",
        designation: "Co-Founder",
        twitterLink: "https://twitter.com/tanmaigo",
        about:
          "Tanmai is the co-founder of hasura.io. He is a StackOverflow powered fullstack, polyglot developer whose areas of interest and work span react, GraphQL, nodejs, python, haskell, docker, postgres, kubernetes. He is passionate about making it easy to build things and is the instructor of India's largest MOOC imad.tech with over 250,000 students.",
      },
    ],
  },
  {
    url: "relay-talk",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl: "https://hasura.io/events/hasura-con-2020/talks/relay-talk/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Relay + Hasura ❤️",
    videoLink: "https://www.youtube.com/watch?v=aoNiUkYLguM",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/RZ4868046",
    time: "10:00 PDT",
    date: "24-06-2020",
    talkType: [
      {
        title: "Hasura Team",
        Icon: icon1,
      },
    ],
    frameBg: frameBg6,
    description: {
      lists: [
        "Learn all about the benefits of Relay on the client side, Relay’s server spec, and see a demo of how to use Relay with Hasura.",
      ],
    },
    paginationImg: sezgiUlucam,
    paginationName: "Sezgi Ulucam",
    speakersList: [
      {
        textColor: "pinkColor",
        profileBg: speakerBg6,
        name: "Sezgi Ulucam",
        img: sezgiUlucam,
        org: "Hasura",
        orgLink: "https://hasura.io/",
        designation: "Developer advocate",
        twitterLink: "https://twitter.com/sez",
      },
    ],
  },
  {
    url: "getting-started-with-hasura-pro",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/getting-started-with-hasura-pro/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Getting started with Hasura Pro",
    videoLink: "https://www.youtube.com/watch?v=H-hxIXF2hWU",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/pU4867773",
    time: "12:15 PDT",
    date: "22-06-2020",
    talkType: [
      {
        title: "Hasura Team",
        Icon: icon1,
      },
    ],
    frameBg: frameBg1,
    paginationImg: tanmaiGopal,
    paginationName: "Tanmai Gopal",
    speakersList: [
      {
        textColor: "greenColor",
        profileBg: speakerBg1,
        name: "Tanmai Gopal",
        img: tanmaiGopal,
        org: "Hasura",
        orgLink: "https://hasura.io/",
        designation: "Co-Founder",
        twitterLink: "https://twitter.com/tanmaigo",
        about:
          "Tanmai is the co-founder of hasura.io. He is a StackOverflow powered fullstack, polyglot developer whose areas of interest and work span react, GraphQL, nodejs, python, haskell, docker, postgres, kubernetes. He is passionate about making it easy to build things and is the instructor of India's largest MOOC imad.tech with over 250,000 students.",
      },
    ],
  },
  {
    url: "using-remote-joins-to-create-a-unified-graphQL-api-for-your-company",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/using-remote-joins-to-create-a-unified-graphQL-api-for-your-company/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Using Remote Joins to create a unified GraphQL API for your company",
    videoLink: "https://www.youtube.com/watch?v=ZbdKD3_egSU",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/RP4867780",
    time: "9:25 PDT",
    date: "23-06-2020",
    talkType: [
      {
        title: "Hasura Team",
        Icon: icon1,
      },
      {
        title: "Remote Joins",
        Icon: icon2,
      },
    ],
    frameBg: frameBg2,
    description: {
      lists: [
        "With cloud becoming commonplace, developers now have a vast number of ways in which they can architect their apps. They can choose to build a monolithic app for strongly consistent changes, or they can choose a microservices architecture for high agility & independence. And ofcourse, they can even use out-of-the-box hosted services for minimal dev and ops investment. But with such a cocktail of infrastructure and data sources, how do you get all the data you need quickly and securely?",
        "Introducing Hasura Remote Joins. Remote Joins allows you to create relationships across different data sources. The data sources may expose different interfaces like GraphQL, REST or even native protocols but you can join them because of GraphQL's type system! By creating all these relationships, essentially what you have done is created a unified GraphQL API for your entire company! Combined with Hasura's permission system, you can further separate the unified graph into secure role-based views and actions on your data.",
        'The best part is all the unification happens at the Hasura layer using declarative configuration. This means your underlying data sources & APIs can evolve independently and you get complete data federation. The join, authorization logic and consistency checks are handled by Hasura and the execution logic remains highly performant as Hasura "pushes down" the heavy-lifting to the underlying sources as much as possible. With Remote Joins, Hasura will be a revolutionary solution in providing data agility to your teams and allow you to completely harness the power of your data.',
      ],
    },
    paginationImg: tirumaraiSelvan,
    paginationName: "Tirumarai Selvan",
    speakersList: [
      {
        textColor: "blueColor",
        profileBg: speakerBg2,
        name: "Tirumarai Selvan",
        img: tirumaraiSelvan,
        org: "Hasura",
        orgLink: "https://hasura.io/",
        designation: "Product Manager",
        twitterLink: "https://twitter.com/tirumarai",
        about:
          "Tiru is a product manager at Hasura, a GraphQL company.  He is the lead developer of Hasura Eventing system which enables building data applications using serverless patterns. He is also the core contributor for Gitkube and 3factor.app. He is experienced in all layers of the stack from Javascript to Haskell, from bare-metal to containers. Most of his days are spent trying to understand how to improve developer productivity and enterprise agility in building data products.",
      },
    ],
  },
  {
    url: "how-we-use-hasura-at-hasura",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl: "https://hasura.io/events/hasura-con-2020/talks/how-we-use-hasura-at-hasura/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "How we use Hasura at Hasura",
    videoLink: "https://www.youtube.com/watch?v=ZT-XD1-dzE8",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/Ln4867789",
    time: "11:05 PDT",
    date: "23-06-2020",
    talkType: [
      {
        title: "Hasura Team",
        Icon: icon1,
      },
    ],
    frameBg: frameBg3,
    paginationImg: shahidhMuhammed,
    paginationName: "Shahidh K Muhammed",
    speakersList: [
      {
        noShow: true,
        textColor: "whiteColor",
        profileBg: speakerBg3,
        name: "Shahidh K Muhammed",
        img: shahidhMuhammed,
        org: "Hasura",
        orgLink: "https://hasura.io/",
        designation: "Tech Lead for Enterprise Products",
        twitterLink: "https://twitter.com/shahidh_k",
        about:
          "Shahidh is an engineer at Hasura and one of the maintainers of Hasura GraphQL Engine. He, along with the team at Hasura, are exploring ways to make application development easier, using GraphQL and serverless. He is the co-author of Graphqurl, an open-source curl like CLI for making GraphQL queries. Shahidh is an experienced speaker who has spoken at many conferences in India and abroad.",
      },
    ],
  },
  {
    url: "clinical-platform-approach-using-graphql-serverless-microfrontends",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/clinical-platform-approach-using-graphql-serverless-microfrontends/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Clinical Platform Approach using GraphQL, serverless, Microfrontends",
    videoLink: "https://www.youtube.com/watch?v=ZRv3eV4gIv8",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/kC4914724",
    time: "11:30 PDT",
    date: "22-06-2020",
    talkType: [
      {
        title: "Healthcare",
        Icon: icon1,
      },
    ],
    frameBg: frameBg4,
    paginationImg: gurumurthySithuraj,
    paginationName: "Gurumurthy Sithuraj",
    speakersList: [
      {
        textColor: "yellowColor",
        profileBg: speakerBg4,
        name: "Gurumurthy Sithuraj",
        img: gurumurthySithuraj,
        org: "UnitedHealth Group",
        orgLink: "https://www.linkedin.com/company/unitedhealth-group/",
        designation: "Director of IT",
        linkedInLink: "https://www.linkedin.com/in/gurumurthysithuraj/",
      },
    ],
  },
  {
    url: "hasuracon-20-data-driven-application-development-in-the-cloud",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/hasuracon-20-data-driven-application-development-in-the-cloud/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Hasuracon ’20: data-driven application development in the cloud",
    videoLink: "https://www.youtube.com/watch?v=CAYk2oCnGfU",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/bL4916152",
    time: "9:05 PDT",
    date: "23-06-2020",
    talkType: [
      {
        title: "Data API",
        Icon: icon1,
      },
    ],
    frameBg: frameBg5,
    paginationImg: jamesGovernor,
    paginationName: "James Governor",
    speakersList: [
      {
        textColor: "purpleColor",
        profileBg: speakerBg5,
        name: "James Governor",
        img: jamesGovernor,
        org: "RedMonk",
        orgLink: "https://redmonk.com/",
        designation: "Co-Founder",
        twitterLink: "https://twitter.com/monkchips",
        about:
          "James Governor is co-founder of RedMonk, the only developer-focused industry analyst firm. Based in London, he advises clients on developer-led technology adoption, cloud, open source, community and technology strategy.",
      },
    ],
  },
  {
    url: "accessing-healthcare-solution-delivery-hasura-graphql",
    metaTags: {
      title: "HasuraCon’20: An online Hasura GraphQL user conference",
      canonicalUrl:
        "https://hasura.io/events/hasura-con-2020/talks/accessing-healthcare-solution-delivery-hasura-graphql/",
      description:
        "HasuraCon is a free, online conference. Join us for a week of talks and hand-on workshops about pushing the boundaries of GraphQL forward!",
      metaImg: "https://graphql-engine-cdn.hasura.io/assets/main-site/hasura-con-card.png",
    },
    title: "Accelerating healthcare solution delivery with Hasura GraphQL",
    videoLink: "https://www.youtube.com/watch?v=crma4m3RF3c",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/QU4919181",
    time: "12:50 PDT",
    date: "23-06-2020",
    talkType: [
      {
        title: "Healthcare",
        Icon: icon2,
      },
    ],
    frameBg: frameBg6,
    description: {
      lists: [
        "This talk discusses Philips’ experience with Hasura GraphQL and how it enabled us to accelerate the time to market for our solutions.",
        "In particular, it discusses specific needs/challenges faced by us and how a GraphQL centric architectural approach helped in mitigating the same. The resultant quantified benefits are also indicated.",
      ],
    },
    paginationImg: karthikSrinivasan,
    paginationName: "Karthik Srinivasan",
    speakersList: [
      {
        textColor: "pinkColor",
        profileBg: speakerBg6,
        name: "Karthik Srinivasan",
        img: karthikSrinivasan,
        designation: "Solution Architect",
        org: "Philips Healthcare",
        linkedInLink: "http://www.linkedin.com/in/karthik-srinivasan-philips",
        about:
          "Karthik Srinivasan is currently a Solution Architect with Philips Healthcare. He has ~26 years of experience building systems and solutions for healthcare, networking and communication domains. At Philips, he has been involved in architecting solutions in telehealth and diagnostic imaging spaces.",
      },
    ],
  },
];

const dayOne = [
  {
    type: "talks",
    url: "graphql-as-infrastructure",
  },
  {
    type: "talks",
    url: "building-a-complex-multi-tenant-saas-application-with-hasura",
  },
  {
    type: "talks",
    url: "accessing-cherres-real-estate-knowledge-graph-with-a-single-graphQL-api",
  },
  {
    type: "talks",
    url: "building-a-multi-tenant-geospatial-data-platform-with-hasura",
  },
  {
    type: "talks",
    url: "making-breaking-api-changes-without-breaking-your-consumer-app",
  },
  {
    type: "talks",
    url: "a-tale-of-startups-and-graphql",
  },
  {
    type: "talks",
    url: "clinical-platform-approach-using-graphql-serverless-microfrontends",
  },
  {
    type: "talks",
    url: "0-100-experiences-with-hasura-in-production",
  },
  {
    type: "talks",
    url: "getting-started-with-hasura-pro",
  },
  {
    type: "talks",
    url: "powering-autonomous-delivery-logistics-at-matternet",
  },
];
const dayTwo = [
  {
    type: "talks",
    url: "hasuracon-20-data-driven-application-development-in-the-cloud",
  },
  {
    type: "talks",
    url: "using-remote-joins-to-create-a-unified-graphQL-api-for-your-company",
  },
  {
    type: "talks",
    url: "integrating-hasura-into-an-existing-graphql-ecosystem-with-remote-schemas",
  },
  {
    type: "talks",
    url: "exploring-hasura-as-data-access-layer-in-distributed-systems",
  },
  {
    type: "talks",
    url: "lessons-learnt-in-using-hasura-for-fintech-apps",
  },
  {
    type: "talks",
    url: "bringing-graphql-to-the-edge",
  },
  {
    type: "talks",
    url: "how-we-use-hasura-at-hasura",
  },
  {
    type: "talks",
    url: "how-to-deploy-hasura-on-aws-using-a-language-you-already-know",
  },
  {
    type: "talks",
    url: "graphql-everywhere-use-hasura-graphql-mesh-to-create-the-ultimate-data-graph",
  },
  {
    type: "talks",
    url: "building-your-own-code-driven-workflow-on-top-of-Hasura-declarative-configuration",
  },
  {
    type: "talks",
    url: "hasuras-role-in-data-journalism",
  },
  {
    type: "talks",
    url: "accessing-healthcare-solution-delivery-hasura-graphql",
  },
];
const dayThree = [
  {
    type: "talks",
    url: "how-hasura-makes-learning-code-easier",
  },
  {
    type: "talks",
    url: "blazing-fast-hasura-developer-experience-using-nhost",
  },
  {
    type: "talks",
    url: "hasura-and-the-graphql-cms",
  },
  {
    type: "talks",
    url: "blazing-fast-deployment-of-a-fullstack-angular-GraphQL-hasura-app-with-qovery",
  },
  {
    type: "talks",
    url: "relay-talk",
  },
  {
    type: "talks",
    url: "going-static-in-a-dynamic-world-with-hasura-and-Nuxt-js",
  },
  {
    type: "talks",
    url: "swiftui-with-hasura-and-apollo-the-good-The-Bad-and-the-unspeakably-ugly",
  },
  {
    type: "talks",
    url: "building-realtime-and-collaborative-games-with-hasura-unity",
  },
  {
    type: "talks",
    url: "rails-vs-hasura",
  },
  /*
  {
    type: 'talks',
    url: 'full-stack-react-native-in-20-minutes',
  },
  */
  {
    type: "talks",
    url: "bootstrapping-a-medical-mask-listing-platform-in-three-days-using-hasura",
  },
  {
    type: "talks",
    url: "bugs-cant-hide-a-full-stack-exploration-in-type-safety",
  },
];
const scheduleDetails = [
  {
    type: "talks",
    url: "graphql-as-infrastructure",
  },
  {
    type: "talks",
    url: "building-a-complex-multi-tenant-saas-application-with-hasura",
  },
  {
    type: "talks",
    url: "accessing-cherres-real-estate-knowledge-graph-with-a-single-graphQL-api",
  },
  {
    type: "talks",
    url: "building-a-multi-tenant-geospatial-data-platform-with-hasura",
  },
  {
    type: "talks",
    url: "making-breaking-api-changes-without-breaking-your-consumer-app",
  },
  {
    type: "talks",
    url: "a-tale-of-startups-and-graphql",
  },
  {
    type: "talks",
    url: "clinical-platform-approach-using-graphql-serverless-microfrontends",
  },
  {
    type: "talks",
    url: "0-100-experiences-with-hasura-in-production",
  },
  {
    type: "talks",
    url: "getting-started-with-hasura-pro",
  },
  {
    type: "talks",
    url: "powering-autonomous-delivery-logistics-at-matternet",
  },
  {
    type: "talks",
    url: "hasuracon-20-data-driven-application-development-in-the-cloud",
  },
  {
    type: "talks",
    url: "using-remote-joins-to-create-a-unified-graphQL-api-for-your-company",
  },
  {
    type: "talks",
    url: "integrating-hasura-into-an-existing-graphql-ecosystem-with-remote-schemas",
  },
  {
    type: "talks",
    url: "exploring-hasura-as-data-access-layer-in-distributed-systems",
  },
  {
    type: "talks",
    url: "lessons-learnt-in-using-hasura-for-fintech-apps",
  },
  {
    type: "talks",
    url: "bringing-graphql-to-the-edge",
  },
  {
    type: "talks",
    url: "how-we-use-hasura-at-hasura",
  },
  {
    type: "talks",
    url: "how-to-deploy-hasura-on-aws-using-a-language-you-already-know",
  },
  {
    type: "talks",
    url: "graphql-everywhere-use-hasura-graphql-mesh-to-create-the-ultimate-data-graph",
  },
  {
    type: "talks",
    url: "building-your-own-code-driven-workflow-on-top-of-Hasura-declarative-configuration",
  },
  {
    type: "talks",
    url: "hasuras-role-in-data-journalism",
  },
  {
    type: "talks",
    url: "accessing-healthcare-solution-delivery-hasura-graphql",
  },
  {
    type: "talks",
    url: "how-hasura-makes-learning-code-easier",
  },
  {
    type: "talks",
    url: "blazing-fast-hasura-developer-experience-using-nhost",
  },
  {
    type: "talks",
    url: "hasura-and-the-graphql-cms",
  },
  {
    type: "talks",
    url: "blazing-fast-deployment-of-a-fullstack-angular-GraphQL-hasura-app-with-qovery",
  },
  {
    type: "talks",
    url: "relay-talk",
  },
  {
    type: "talks",
    url: "going-static-in-a-dynamic-world-with-hasura-and-Nuxt-js",
  },
  {
    type: "talks",
    url: "swiftui-with-hasura-and-apollo-the-good-The-Bad-and-the-unspeakably-ugly",
  },
  {
    type: "talks",
    url: "building-realtime-and-collaborative-games-with-hasura-unity",
  },
  {
    type: "talks",
    url: "rails-vs-hasura",
  },
  /*
  {
    type: 'talks',
    url: 'full-stack-react-native-in-20-minutes',
  },
  */
  {
    type: "talks",
    url: "bootstrapping-a-medical-mask-listing-platform-in-three-days-using-hasura",
  },
  {
    type: "talks",
    url: "bugs-cant-hide-a-full-stack-exploration-in-type-safety",
  },
];
const workshopDetails = [
  {
    url: "enterprisegrade",
    title: "Enterprise-grade GraphQL Authorization",
    addCalendar: false,
    time: "9:00 PST",
    talkType: [
      {
        title: "18th June",
        Icon: icon1,
      },
      {
        title: "9am to 12pm PST",
        Icon: icon2,
      },
    ],
    description: {
      lists: [
        "Learn how to connect your auth systems to Hasura and how to implement any kind of authorization: rules, roles, tags, hierarchies, attribute based systems!",
      ],
    },
    speakersList: [
      {
        name: "Tanmai Gopal",
        img: tanmaiGopal,
        org: "Hasura",
        orgLink: "https://hasura.io/",
        designation: "Co-Founder",
        twitterLink: "https://twitter.com/tanmaigo",
      },
      {
        name: "Tirumarai Selvan",
        img: tirumaraiSelvan,
        org: "Hasura",
        orgLink: "https://hasura.io/",
        designation: "Product Manager",
        twitterLink: "https://twitter.com/tirumarai",
      },
    ],
  },
  {
    url: "architectingdomaindriven",
    title: "Architecting domain-driven GraphQL apps",
    addCalendar: false,
    time: "9:00 PST",
    talkType: [
      {
        title: "19th June",
        Icon: icon1,
      },
      {
        title: "9am to 12pm PST",
        Icon: icon2,
      },
    ],
    description: {
      lists: [
        "Setup a reference architecture for your team to build complex GraphQL apps with Hasura. Integrate your favourite frontend, backend, CI/CD tooling for maximum feature velocity.",
      ],
    },
    speakersList: [
      {
        name: "Tanmai Gopal",
        img: tanmaiGopal,
        org: "Hasura",
        orgLink: "https://hasura.io/",
        designation: "Co-Founder",
        twitterLink: "https://twitter.com/tanmaigo",
      },
      {
        name: "Tirumarai Selvan",
        img: tirumaraiSelvan,
        org: "Hasura",
        orgLink: "https://hasura.io/",
        designation: "Product Manager",
        twitterLink: "https://twitter.com/tirumarai",
      },
    ],
  },
  {
    url: "scaling",
    title: "Scaling Hasura from 10 to 1M reqs/s",
    addCalendar: false,
    addCalendarLink: "https://www.addevent.com/event/kb4811907",
    time: "9:00 PDT",
    talkType: [
      {
        title: "15th July",
        Icon: icon1,
      },
      {
        title: "09am to 12pm PDT",
        Icon: icon2,
      },
    ],
    description: {
      lists: [
        "Scale a fully loaded GraphQL application built with Hasura (complete with auth & custom business logic) from 10 req/s to 1 million req/s without any downtime.",
      ],
    },
    speakersList: [
      {
        name: "Tanmai Gopal",
        img: tanmaiGopal,
        org: "Hasura",
        orgLink: "https://hasura.io/",
        designation: "Co-Founder",
        twitterLink: "https://twitter.com/tanmaigo",
      },
      {
        name: "Shahidh K Muhammed",
        img: shahidhMuhammed,
        org: "Hasura",
        orgLink: "https://hasura.io/",
        designation: "Tech Lead for Enterprise Products",
        twitterLink: "https://twitter.com/shahidh_k",
      },
    ],
  },
];
export { talksDetails, dayOne, dayTwo, dayThree, workshopDetails, scheduleDetails };
